export * from './tibetan-syllable-parser/tibetan-syllable-parser.js';
